import { render, staticRenderFns } from "./appTerms.vue?vue&type=template&id=7e0fe9ae&"
import script from "./appTerms.vue?vue&type=script&lang=js&"
export * from "./appTerms.vue?vue&type=script&lang=js&"
import style0 from "./appTerms.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e0fe9ae')) {
      api.createRecord('7e0fe9ae', component.options)
    } else {
      api.reload('7e0fe9ae', component.options)
    }
    module.hot.accept("./appTerms.vue?vue&type=template&id=7e0fe9ae&", function () {
      api.rerender('7e0fe9ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "common/components/appTerms.vue"
export default component.exports